module.exports = __webpack_public_path__ + "img/hr-wooden-particle-20.4bda37b9.png";